let _visibilityHandler = null;
let _blurHandler = null;
let _suppressFocusViolations = false;
let _suppressTimeout = null;
let _multiDisplayInterval = null;
let _multiDisplayActive = false;

let _lastMonitorEventTime = 0;
const MONITOR_THROTTLE = 200;
const MULTI_DISPLAY_CHECK_INTERVAL = 5000;

const suppressFocus = (ms = 3000) => {
  if (_suppressTimeout) clearTimeout(_suppressTimeout);
  _suppressFocusViolations = true;
  _suppressTimeout = setTimeout(() => {
    _suppressFocusViolations = false;
    _suppressTimeout = null;
  }, ms);
};

export const monitorState = {};
export const monitorGetters = {};
export const monitorMutations = {};

export const monitorActions = {
  startMonitorProctoring({ dispatch }) {
    if (_visibilityHandler) return;

    _visibilityHandler = () => {
      const now = Date.now();
      if (now - _lastMonitorEventTime < MONITOR_THROTTLE) return;

      if (_suppressFocusViolations) return;
      if (document.hidden) {
        _lastMonitorEventTime = now;
        dispatch("triggerViolation", {
          type: "TAB_SWITCH",
          reason: "User switched browser tab",
        });
      }
    };

    _blurHandler = () => {
      const now = Date.now();
      if (now - _lastMonitorEventTime < MONITOR_THROTTLE) return;

      if (_suppressFocusViolations) return;
      _lastMonitorEventTime = now;
      dispatch("triggerViolation", {
        type: "APP_SWITCH",
        reason: "User switched application / lost focus",
        isLog: true,
      });
    };

    document.addEventListener("visibilitychange", _visibilityHandler);
    window.addEventListener("blur", _blurHandler);

    if (typeof window.screen?.isExtended !== "undefined") {
      _multiDisplayInterval = setInterval(() => {
        if (window.screen.isExtended) {
          if (!_multiDisplayActive) {
            _multiDisplayActive = true;
            dispatch("triggerViolation", {
              type: "MULTIPLE_DISPLAYS",
              reason: "Multiple displays detected",
              isLog: true,
            });
          }
        } else {
          _multiDisplayActive = false;
        }
      }, MULTI_DISPLAY_CHECK_INTERVAL);
    }
  },

  stopMonitorProctoring() {
    if (_visibilityHandler) {
      document.removeEventListener("visibilitychange", _visibilityHandler);
      _visibilityHandler = null;
    }
    if (_blurHandler) {
      window.removeEventListener("blur", _blurHandler);
      _blurHandler = null;
    }
    if (_multiDisplayInterval) {
      clearInterval(_multiDisplayInterval);
      _multiDisplayInterval = null;
    }
    _multiDisplayActive = false;
  },

  suppressFocusViolations(context, { duration = 5000 } = {}) {
    suppressFocus(duration);
  },
};
